import auth from "./auth";
import { createRouter, createWebHistory } from "vue-router";

import Home from "./views/home";
import defaultLayout from "./layouts/side-nav-inner-toolbar";
import simpleLayout from "./layouts/single-card";
import ChangePassword from "./views/change-password"
import fn from "./utils/function";

import AUSR from "./views/_transaction/AUSR";
import AVUL from "./views/_transaction/AVUL";
import AMAP from "./views/_transaction/AMAP";
import AOBJ from "./views/_transaction/AOBJ";
import AERD from "./views/_transaction/AERD";
import UVMC from "./views/_transaction/UVMC";
import UVTM from "./views/_transaction/UVTM";
import ASPC from "./views/_transaction/ASPC";
import AATH from "./views/_transaction/AATH";

function loadView(view) {
  return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

const router = new createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        transName: "Home",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: loadView("login-form")
    },
    {
      path: "/change-password",
      name: "change-password",
      meta: {
        transName: "비밀번호 변경",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: ChangePassword
    },  
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    },
    {
      path: "/ausr",
      name: "ausr",
      meta: {
        transName: "사용자 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AUSR
    },     
    {
      path: "/avul",
      name: "avul",
      meta: {
        transName: "로그인 이력",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AVUL
    },
    {
      path: "/amap",
      name: "amap",
      meta: {
        transName: "맵 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AMAP
    },
    {
      path: "/aobj",
      name: "aobj",
      meta: {
        transName: "오브젝트 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AOBJ
    },
    {
      path: "/aerd",
      name: "aerd",
      meta: {
        transName: "이벤트 로우 데이터 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AERD
    },
    {
      path: "/uvmc",
      name: "uvmc",
      meta: {
        transName: "맵/콘텐츠 통계",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: UVMC
    },
    {
      path: "/uvtm",
      name: "uvtm",
      meta: {
        transName: "시간/일/주/월 접속자 통계",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: UVTM
    },
    {
      path: "/aspc",
      name: "aspc",
      meta: {
        transName: "스페이스 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: ASPC
    },
    {
      path: "/aath",
      name: "aath",
      meta: {
        transName: "스페이스 정보",
        requiresAuth: true,
        layout: defaultLayout
      },
      component: AATH
    }
  ]
});

router.beforeEach((to, from, next) => {

  auth.loggedIn(to.name, 'Y').then(loggedIn => {
      if (to.name === "login-form" && loggedIn == 'SUCCESS') {
        next({ name: "home" });
      }
  
      if (to.matched.some(record => record.meta.requiresAuth)) {        
        if (loggedIn == 'NEED_CHANGE_PASSWORD') {
          fn.alert("초기 비밀번호 변경 후 사용 필요", "정보");
          if(from.name != 'change-password'){
            next({ name: "change-password" });
          }
        }else if (loggedIn != 'SUCCESS') {
          next({ name: "login-form" });
        } else {
          next();
        }
      } else {
        next();
      } 
  });
});

export default router;
